import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { PATH_URL } from 'src/helpers'
import { getQueryParameters } from 'src/helpers/tool'
import { preserveUrlParams } from 'src/helpers/preserveUrlParams'
import { ANIMATION_CONSTANTS } from '../constants'
import { useBulkRecord } from './useBulkRecord'

export const useFlowerAnimation = () => {
  const [activeFlowerIndex, setActiveFlowerIndex] = useState(0)
  const history = useHistory()
  const params = getQueryParameters()
  const collectionIdFromUrl = params.get('collectionId')
  const collectionsQuizEntry = JSON.parse(localStorage.getItem('collectionsQuizEntry') || '{}')
  const collectionIdFromStorage = collectionsQuizEntry.collectionId
  const hasCollectionId = collectionIdFromUrl || collectionIdFromStorage

  const { isLoading, error, isCompleted } = useBulkRecord()

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFlowerIndex((prev) => (prev + 1) % ANIMATION_CONSTANTS.TOTAL_FLOWERS)
    }, ANIMATION_CONSTANTS.FLOWER_ANIMATION_INTERVAL)

    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    if (hasCollectionId) {
      const redirectTimeout = setTimeout(() => {
        const nextUrl = preserveUrlParams(PATH_URL.COLLECTIONS_QUIZ_PARTNER_FULL_NAME)
        history.push(nextUrl)
      }, ANIMATION_CONSTANTS.REDIRECT_DELAY)
      return () => {
        clearTimeout(redirectTimeout)
      }
    }
    if (isCompleted && !isLoading) {
      const redirectTimeout = setTimeout(() => {
        const nextUrl = preserveUrlParams(PATH_URL.COLLECTIONS_QUIZ_ESSENTIALS)
        history.push(nextUrl)
      }, ANIMATION_CONSTANTS.REDIRECT_DELAY)
      return () => {
        clearTimeout(redirectTimeout)
      }
    }
  }, [isCompleted, isLoading, history, hasCollectionId])

  return {
    activeFlowerIndex,
    isLoading,
    error,
    isCompleted,
  }
}
